
import { useState } from 'react';

const FAQSection = () => {
  // Start with no accordion open
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question:
        'What is the difference between red light and infrared light therapy?',
      answer:
        'Red light (630nm-660nm) works on the surface level and is excellent for skin rejuvenation, collagen production, and wound healing. Near-infrared light (810nm-850nm) penetrates deeper into tissues, muscles, and joints, making it ideal for pain relief, inflammation reduction, and muscle recovery. Infrared therapy often shows immediate benefits, while red light therapy provides cumulative benefits with consistent use over time.',
    },
    {
      question: 'How quickly will I see results from infrared therapy?',
      answer:
        'Many customers report immediate benefits from infrared therapy, including reduced pain, improved circulation, and muscle relaxation after just one session. The deep-penetrating wavelengths work quickly to reduce inflammation and promote healing at the cellular level. For optimal results, we recommend regular sessions as part of your wellness routine.',
    },
    {
      question: 'What about red light therapy results?',
      answer:
        'Red light therapy provides excellent benefits, but they typically develop over an extended usage period with commitment. Most users notice improvements in skin texture, tone, and overall appearance after 4-8 weeks of consistent use (3-5 sessions per week). The key to success with red light therapy is consistency and patience, as it works by stimulating natural cellular processes that take time to manifest visible results.',
    },
    {
      question: 'Are these products suitable for both commercial and residential use?',
      answer:
        'Yes! Our product line is specifically tailored for both commercial and residential applications. Our therapy beds (Nova-5500, Nova-R5200, Nova-R1160) are perfect for spas, wellness centers, gyms, and medical practices, while our panels and mats are ideal for home use, personal training studios, and smaller commercial spaces. All products meet the same rigorous quality standards regardless of application.',
    },
    {
      question: 'What warranty do you offer on your products?',
      answer:
        'We stand behind the quality of our products with comprehensive warranty coverage. All therapy beds come with a 3-year warranty on major components and a 1-year warranty on LED panels. Panels and mats include a 2-year warranty covering manufacturing defects and component failures. We also provide lifetime technical support and access to replacement parts. Our US‑based team ensures quick response times and seamless warranty service—no international complications.',
    },
    {
      question:
        'Why should I buy from a US distributor instead of directly from overseas?',
      answer:
        'Working with NovaRadiance Distribution eliminates all the challenges of international purchasing. You get same‑time‑zone communication, no language barriers, faster shipping, simplified warranty claims, and expert guidance in English. We handle all import complexities, provide local support, and ensure you receive properly certified products that meet US standards. Plus, our team understands the American market and can provide tailored advice for your specific needs.',
    },
    {
      question: 'Do you provide training and support after purchase?',
      answer:
        'Absolutely! We provide comprehensive support including online installation and operation training, customized marketing materials (brochures, flyers, treatment plans), inventory management assistance, and ongoing technical support. For commercial clients, we also offer business development guidance and market insights to help you maximize your investment.',
    },
    {
      question: 'What certifications do your products have?',
      answer:
        'All our products are manufactured in ISO 13485‑certified facilities and meet international quality standards. Products are tested for safety certifications including CE, FCC, and RoHS compliance. We can provide all necessary documentation for your peace of mind and regulatory requirements.',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-serif text-4xl md:text-5xl font-light text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Everything you need to know about our products and services
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm overflow-hidden"
            >
              <button
                onClick={() =>
                  setOpenIndex(openIndex === index ? null : index)
                }
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="font-medium text-gray-900 pr-8">{faq.question}</h3>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                  {/* Icon toggles between “add” and “subtract” */}
                  <i
                    className={`ri-${
                      openIndex === index ? 'subtract' : 'add'
                    }-line text-xl text-gray-600`}
                  ></i>
                </div>
              </button>

              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Still have questions? We're here to help!</p>
          <button className="bg-gray-900 text-white px-8 py-3 rounded-md text-sm font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap">
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
